import {useEffect} from "react";
import {Link} from "react-router-dom";

const NotFound = () => {
    useEffect(() => {
        document.getElementsByTagName("main")[0].classList.add("justify-content-center");
    }, []);
    return (
        <div className="row">
            <div className="col-12">
                <h1>404 - Not Found</h1>
                <h3>This page was not found</h3>
                <p><Link to="/" className="btn btn-primary">Home</Link></p>
            </div>
        </div>
    )
}
export default NotFound;